import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import { isMobile } from "react-device-detect";

export default class BeforeGuidepopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open: false
    }
  }

  Open()
  {
    this.setState({
      open: true
    });
  }
  Close()
  {
    this.setState({
        open: false
    });
  }
  Next()
  {
    let confirmCheckbox = $('#confirmCheckbox').is(':checked');
    if( confirmCheckbox )
    {
      this.Close();
      this.props.onCheckComplete('O');
    } else {
      alert('동의가 필요합니다.');
    }

  }
  render()
  {
    let self = this;
    return(
      <Modal open={this.state.open}  onClose={()=>{self.Close()}}   center>
        <div className="modal-dialog modal-md mb0">
          <div className={ '' + ((isMobile) ? '' : 'popupPadding2')}>
            <div className="md-popup-header2 relative">
            단말기 주문후 필수 확인 사항 입니다.
            </div>
            <div className="md-popup-content">
              <div className="popup-body">
                <div className="custom-body">
                  <div style={{textAlign: "left", fontSize: "14px", lineHeight: "1.6"}}>
                    주문시 아래 내용 100% 필독후 동의하시는 분들에 한해 주문가능하며, 필수 안내사항에 대해 고객 미숙지로 인한 과실 발생 및 패널티에 대해서 당사에 책임이 없음과 주문시 필수 안내사항 필독 및 동의함에 따라 진행됨을 참고 부탁드립니다.
                    <br /><br />
                    <b>★ 필요서류 안내</b><br />
                    * 임지원 본인 개통 : 건강보험자격득실확인서(정부24 당월 발행본) <br />
                    * 임직원 가족 개통 : 임직원 건강보험자격득실확인서 + 가족관계증명서<br />
                    (서류 발급 후 사진 촬영 후 T패밀리몰 카카오톡에 사진 첨부)
                    <br /><br />
                    <b>★ 공통지원금&추가지원금 적용 기준은 접수기준이 아닌 "개통기준"으로 적용됩니다.</b>
                    <br /><br />
                    <b>★ 단말기 불량시 개통일 포함 14일 이내 동일 제품으로 교품 가능 합니다.</b><br />
                    (교품시 AS센터 불량확인서 필수 첨부)<br />
                    단, 기기 재고 상황에 따라 교품이 아닌 취소가 될 수 있는 점 참고 부탁드립니다.
                    <br /><br />
                    <b>★ 고객 단순변심 사유로는 개통취소 불가하오니 신중한 구매 부탁드립니다.</b><br />
                    더불어, 고객 부주의로 인한 제품 스크래치 및 파손의 경우에는 교환이 불가합니다.
                    <br /><br />
                    <b>★ 제휴카드 등록시 개통일 포함 14일 이내 등록가능하며, 그 이후 수정 불가능합니다.</b><br />
                    * 단말기 할인형(라이트할부카드) 카드 등록시 해당 카드사로 신규/교체 발급 후 대표번호(1599-5168)로 연락필수<br />
                    *자동이체 할인(요금할인)형 카드는 등록기간 제한 없음.
                    <br /><br />
                    <b>★ 단말기 보험가입은 필수가입이 아니므로, 필요시 개통일 포함 60일 이내 가입 및 상품변경 가능하며, 그 이후 가입 및 타보험 상품으로 변경 불가합니다.</b><br />
                    (아이폰케어 상품은 일반 보험 상품과는 가입조건이 상이하므로, 개통시 별도 문의필요)
                    <br /><br />
                    <b>★요금제 변경 가능일 : 개통일+180일</b><br />
                    - 단말기 개통시 : D+180일 유지후 월정액 43,000원 이상 요금제로 변경가능<br />
                    (42,000원 이하 요금제로 변경시 위약금 부과/공통지원금약정&선약약정 동일)<br />
                    * 요금제 변경시 데이터 초과금 및 지원금 차액 발생 주의
                    <br /><br />
                    6. 약정기간 이내 해지시 위약금 발생 및 요금제 필수 유지기간 미 유지지 패널티가 발생하오니 유의 부탁드립니다.(개통 후 180일이간 위약금 고정 / 181일 ~ 일할 계산 반영)
                    <br /><br />
                    7. 개통자 = 실사용자 사용이 원칙이며, 유심 기변은 개통후 6개월 후 가능합니다.
                    <br /><br />
                  </div>
                </div>
              </div>
              <div className="row text-center pt10">
                <div className="pretty p-icon p-rotate">
                  <input type="checkbox" id="confirmCheckbox" />
                  <div className="state p-danger">
                    <i className="icon fa fa-check"></i>
                    <label>위의 내용을 확인하였습니다</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-footer">
                <div className="row">
                    <div className="col-xs-12 text-center">
                      <a href="#check" onClick={()=>{self.Next()}} className={'btn btn-bar btn-select2 ' + ((isMobile) ? 'btn-xs' : 'btn-md' )  }>확인</a>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

}

